import { Component } from '@angular/core';

@Component({
  template: `
    <h2 mat-dialog-title>Preview Welcome Email</h2>
    <div mat-dialog-title class="details">
      The text between the braces {{ '{}' }} is dynamic. The braces and text will be replaced with information related
      to your company and the email recipient.
    </div>
    <mat-dialog-content>
      <img src="/static/images/welcome_message.png" />
    </mat-dialog-content>
    <mat-dialog-actions>
      <button mat-flat-button mat-dialog-close color="primary">Back</button>
    </mat-dialog-actions>
  `,
  styleUrls: ['../../common/dialog.component.scss', './preview-welcome-email-dialog.component.scss'],
})
export class PreviewWelcomeEmailComponent {}
